import React, { Component } from 'react';
import './header.scss';
import Logo from '../../assets/images/logo.png';
import {
    Navbar,
    NavbarBrand,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import { logout } from '../../helper';
import withAuth from '../../components/Services/WithAuth';
import AuthService from '../../components/Services/AuthService';
import { Link } from "react-router-dom";
import ServerOn from './ServerOnModal/index';

class AdminHeader extends Component {
    constructor(props, state) {
        super(props, state);
        //this.state = {showSide:false,showTop:false};
        this.Auth = new AuthService();
        this.state = { serverOnModal: false }
    }
    deleteUserInfo = (event) => {
        event.preventDefault()
        logout();
        this.props.logout();
        this.props.history.push('/login');
    }

    serverDatesModal = () => {
        this.setState({ serverOnModal: !this.state.serverOnModal })
    }

    render() {
        const location = this.props.history.location;
        return (
            <header>
                <Navbar className={location.pathname.includes("case/companysearch/") ? "app-header fixed-top justify-content-between bg-light disabled" : "app-header fixed-top justify-content-between bg-light"} expand="md">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="btn-left-nav mr-1 mt-1" onClick={this.props.showHideMenu}>
                            <i className="icon-menu"></i>
                        </div>
                        <NavbarBrand href="/"><img src={Logo} alt="logo" width="110" height="28" /></NavbarBrand>
                    </div>
                    <div className="d-flex justify-content-end justify-content-sm-between align-items-center">
                        <div className="app-header__right d-flex align-items-center justify-content-center">
                            <UncontrolledDropdown className="dropdown-user">
                                <DropdownToggle caret className="dropdown-user__name px-3 d-flex align-items-center">
                                    <i className="icon-user mr-sm-3"></i> <span className="d-none d-sm-inline-block">{this.props.user.eml}</span>
                                </DropdownToggle>
                                <DropdownMenu className="px-3">
                                    {/* <DropdownItem className="dropdown-user__item p-0" onClick={() => this.serverDatesModal()}>
                                        <Link className="py-3 d-inline-block" to="" >Server ON/OFF</Link>
                                    </DropdownItem> */}
                                    <DropdownItem className="dropdown-user__item p-0" onClick={this.deleteUserInfo}>
                                        <Link className="py-3 d-inline-block" to="/login" >Logout</Link>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </div>
                </Navbar>

                {this.state.serverOnModal && <ServerOn open={this.state.serverOnModal} serverDatesModal={this.serverDatesModal} />}

            </header>
        );
    }
}

export default withAuth(AdminHeader);
